<template>
  <div>
    <h3 class="title-type-5">
      홀 광고 세부 조건
      <span class="required">
        <v-icon>mdi-check-circle-outline</v-icon>
        필수
      </span>
    </h3>
    <ul class="chx-list-type-1 nine">
      <li v-for="(hole, index) in holes" :key="index">
        <v-checkbox
          v-model="checkedHoles"
          :value="hole"
          :label="hole.toString()"
          color="#fecd00"
          off-icon="mdi-checkbox-blank"
          class="checkbox-type-1"
          :rules="chxRules"
          hide-details
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    propCondition: Array,
  },
  computed: {
    chxRules() {
      return [() => this.checkedHoles.length > 0];
    },
  },
  data: () => ({
    holes: new Array(18).fill(0).map((v, i) => i + 1),
    checkedHoles: [],
  }),
  methods: {
    getValues() {
      return this.checkedHoles;
    },
  },
  created() {
    this.checkedHoles =
      this.propCondition && this.propCondition.length
        ? this.propCondition
        : new Array(18).fill(0).map((v, i) => i + 1);
  },
};
</script>
